import { ButtonIconText } from '@/components';

interface DocumentDownloadButtonsProps {
  objectId: string;
  isViewing: boolean;
  isDownloading: boolean;
  isBusy: boolean;
  onView: (objectId: string) => void;
  onDownload: (objectId: string) => void;
  viewText: string;
  viewLoadingText: string;
  downloadText: string;
  downloadLoadingText: string;
}

/**
 * DocumentDownloadButtons - Standard button variation with text and icons
 * Displays buttons below the file information with full text labels
 */
export function DocumentDownloadButtons({
  objectId,
  isViewing,
  isDownloading,
  isBusy,
  onView,
  onDownload,
  viewText,
  viewLoadingText,
  downloadText,
  downloadLoadingText,
}: DocumentDownloadButtonsProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <ButtonIconText
        iconName="eye"
        onClick={() => void onView(objectId)}
        disabled={isBusy}
        className={isViewing ? 'opacity-50' : ''}
      >
        {isViewing ? viewLoadingText : viewText}
      </ButtonIconText>

      <ButtonIconText
        iconName="download"
        onClick={() => void onDownload(objectId)}
        disabled={isBusy}
        className={isDownloading ? 'opacity-50' : ''}
      >
        {isDownloading ? downloadLoadingText : downloadText}
      </ButtonIconText>
    </div>
  );
}
